/** @jsxImportSource @emotion/react */
import { useMemo } from "react";
import { useSelector } from "react-redux";
import useConfig from "../../../../actions/Tenants/config/configHook";
import { headerLinks } from "../../../../actions/Tenants/config/constants";
import { isFilledArray } from "../../../../utils";
import useAuthorization from "../../../../utils/authorization";
import { generalLinks } from "./GeneralLink";

export const NavMainLinks = () => {
    // @todo: proper ts
    const { user } = useSelector((state: any) => state.auth);
    const auth = useAuthorization();
    const config = useConfig();
    const primaryHeaderLinks = config.root_config?.primary_header_links;
    // Master gate for the whole Signals feature (EFQ-4145). The "Signals" nav
    // entry only shows when the tenant has the feature enabled.
    const signalsEnabled = !!config.root_config?.ripening_room_enable_signals;

    const hasPrimaryHeaderLinks = useMemo(() => isFilledArray(primaryHeaderLinks), [primaryHeaderLinks]);

    const navMainLinks = useMemo(() => {
        if (hasPrimaryHeaderLinks) {
            const configured = primaryHeaderLinks.filter((item) => item).filter(
                (item) => generalLinks[item.path] && (!isFilledArray(item.roles) || auth.userHasOneOfRoles(item.roles))
                && (!isFilledArray(item.teams) || auth.userBelongsToOneOfTeams(item.teams))
                && (item.path !== headerLinks.signals || signalsEnabled)
            );

            // The master flag alone must surface the feature. Every other
            // Signals surface (room tab, banner, rollup, admin page, and the
            // backend's require_signals_enabled guard) keys off the flag on its
            // own; the nav used to additionally require a hand-added
            // primary_header_links entry, so enabling Signals for a tenant left
            // it with no way in and no error to say why. Appending here keeps
            // the filter above meaningful — an explicitly configured entry
            // still wins, and still disappears when the flag is off.
            const needsSignalsLink = signalsEnabled
                && !configured.some((item) => item.path === headerLinks.signals);
            const withSignals = needsSignalsLink
                ? [...configured, { path: headerLinks.signals, label: null }]
                : configured;

            return withSignals.map((item) => generalLinks[item.path](item.label, item.path_addition));
        }

        const dynamicLinks = user.tenant?.show_powerbi_link ? [headerLinks.insights] : [];
        // Same rule on the hardcoded path: no per-tenant headerMainLinks list
        // contains `signals`, so without this a tenant on the fallback nav would
        // hit the identical dead end.
        const signalsLink = signalsEnabled && !config.headerMainLinks.includes(headerLinks.signals)
            ? [headerLinks.signals]
            : [];
        const linksToShow = [...config.headerMainLinks, ...dynamicLinks, ...signalsLink];

        return linksToShow.map((path) => generalLinks[path]("", ""));
    }, [user, hasPrimaryHeaderLinks, signalsEnabled]);

    return navMainLinks;
};
